import { apiFetch } from '../api-client';

export interface PayslipDetail {
  id: string;
  payrollId: string;
  payrollCode: string;
  period: string;
  status: string;
  disbursedAt: string | null;
  employeeName: string;
  workingDays: number | null;
  otHours: number | null;
  income: {
    baseSalary: number;
    agreedSalary: number;
    overtimeAmount: number;
    allowanceTaxFree: number;
    allowanceTaxable: number;
    bonusAmount: number;
    total: number;
  };
  deduct: {
    bhxhNv: number;
    bhytNv: number;
    bhtnNv: number;
    personalIncomeTax: number;
    advanceDeduct: number;
    total: number;
  };
  net: number;
}

export interface PayslipHistoryItem {
  id: string;
  payrollId: string;
  payrollCode: string;
  period: string;
  status: string;
  disbursedAt: string | null;
  net: number;
  gross: number;
}

export const payslipsApi = {
  list: () => apiFetch<{ items: PayslipHistoryItem[] }>('/api/me/payslips'),
  current: () => apiFetch<PayslipDetail | null>('/api/me/payslips/current'),
  detail: (payrollId: string) => apiFetch<PayslipDetail>(`/api/me/payslips/${payrollId}`),
};
